import { c as _c } from "react/compiler-runtime";
import { IcoSearchSmall16 } from '@onefootprint/icons';
const SearchIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden="true"><IcoSearchSmall16 /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default SearchIcon;